import DIApi from './_diApi';

/**
 * Config API thông tin về các nguồn kinh phí mapping với kho bạc điện tử'
 */
class BudgetSourceDvcApi extends DIApi {
  controllerName = 'BudgetSourceDvcs';
}

export default new BudgetSourceDvcApi();
